module.exports = __webpack_public_path__ + "static/media/user-02-web.2b115e8d.png";